import { createSlice, PayloadAction } from '@reduxjs/toolkit';
//import { ReportCategory } from '../../screens/AnalyticsHub/pages/Reports/reportCatalog';

export type ReportStatus = 'Active' | 'Disabled';
export type ReportType = 'EXTERNAL' | 'INTERNAL_REDIRECT';

export interface ReportConfigRow {
  id: string;
  reportId: number | null;
  name: string;
  primaryTag: string;
  secondaryTags: string[];
  kpiTags: string[];
  status: ReportStatus;
  description: string;
  link: string;
  icon: string;
  reportType?: ReportType;
}

interface ReportingConfigurationState {
  rows: ReportConfigRow[];
}

const initialState: ReportingConfigurationState = {
  rows: [],
};

const reportingConfigurationSlice = createSlice({
  name: 'reportingConfiguration',
  initialState,
  reducers: {
    setReportConfigurationRows: (state, action: PayloadAction<ReportConfigRow[]>) => {
      state.rows = action.payload;
    },
    upsertReportConfigurationRow: (state, action: PayloadAction<ReportConfigRow>) => {
      const nextRow = action.payload;
      const existingIndex = state.rows.findIndex((row) => {
        if (row.reportId != null && nextRow.reportId != null) {
          return row.reportId === nextRow.reportId;
        }

        return row.id === nextRow.id;
      });

      if (existingIndex >= 0) {
        state.rows[existingIndex] = nextRow;
        return;
      }

      state.rows.push(nextRow);
    },
    removeReportConfigurationRow: (state, action: PayloadAction<string>) => {
      state.rows = state.rows.filter((row) => row.id !== action.payload);
    },
    resetReportConfigurationRows: (state) => {
      state.rows = [];
    },
  },
});

export const {
  setReportConfigurationRows,
  upsertReportConfigurationRow,
  removeReportConfigurationRow,
  resetReportConfigurationRows,
} = reportingConfigurationSlice.actions;

export default reportingConfigurationSlice.reducer;
